import React, { Fragment } from 'react'
import Picture from '../../components/Picture'

import './CardsEstrategiasV2.scss'

const Card = ({ imgSrc, imgAlt, title, description, link }) => {
  const content = (
    <Fragment>
      <Picture
        className='new-sales-features-img'
        src={imgSrc}
        alt={imgAlt}
      />
      <div className="card-content">
        <h4 className="card-title">{title}</h4>
        <p className='card-description'>{description}</p>
      </div>
    </Fragment>
  );

  if (link) {
    return (
      <div className="card">
        <a href={link} className="card-link-wrapper">{content}</a>
      </div>
    );
  }

  return <div className="card">{content}</div>;
};

const defaultCards = (links) => ([
  {
    imgSrc: "/images/site/new-home/update/indicadores.png",
    imgAlt: 'Imagem de alguns exemplos de indicadores em um sistema de vendas. Em foco, é possível ver "Análise por Regiões do Brasil", "Positivação de Clientes", "Curva ABC de Clientes" e "Carteira de Clientes", todas disponíveis na aba "Indicadores" do Mercos',
    title: "+ 25 indicadores e relatórios",
    description: "Acompanhe o desempenho da equipe, as metas e a situação das carteiras em tempo real",
    link: links.card1,
  },
  {
    imgSrc: "/images/site/new-home/update/suporte.png",
    imgAlt: 'Imagem do chat em tempo real do sistema de vendas, mostrando a pergunta "Olá, estou com uma dúvida, pode me ajudar?" e a resposta "Claro! Como posso lhe ajudar?"',
    title: <Fragment>Suporte<br/> em tempo real</Fragment>,
    description: <Fragment>Respondemos a toda sua equipe <b>em até 20 segundos</b> no chat ou WhatsApp em horário comercial</Fragment>,
  },
  {
    imgSrc: "/images/site/new-home/update/apoio.png",
    imgAlt: "",
    title: <Fragment>Apoio integral para<br/>  sua equipe de TI</Fragment>,
    description: "Equipe profissional e preparada para tirar dúvidas do time de TI",
  },
  {
    imgSrc: "/images/site/new-home/update/e-commerce.png",
    imgAlt: 'Imagem do E-commerce B2B Mercos com Videochamada, mostrando um site que vende canecas B2B, ou seja, para outras empresas. É possível ver uma caneca preta com a base bege, uma outra caneca preta com o topo cinza e uma jarra preta com cabo bege à venda, para que os clientes comprem diretamente do site, com o vendedor podendo acompanhar de perto, por vídeo',
    title: <Fragment>E-commerce B2B<br/> integrado ao Força de Vendas</Fragment>,
    description: "Clientes compram online com autonomia, condições personalizadas, informações atualizadas e histórico integrado",
    link: links.card4,
  },
  {
    imgSrc: "/images/site/new-home/update/mercos-pay.png",
    imgAlt: 'Imagem de um pedido feito na solução de pagamentos Mercos Pay. É possível ver que o comprador montou um carrinho, passou pela etapa de entrega e agora está na etapa de pagamento. A imagem mostra um pagamento sendo feito por boleto bancário, com quantidade de parcelas e detalhes do parcelamento.',
    title: "Mercos Pay",
    description: "A solução de pagamentos da Mercos permite recebimentos por cartão, boleto, link de pagamento ou Pix, direto do sistema",
    link: links.card5,
  },
  {
    imgSrc: "/images/site/new-home/update/solucoes-ia.png",
    imgAlt: 'Homem de óculos sorrindo e olhando para o celular, feliz por atender o cliente com as soluções com IA da Mercos. Ao seu lado aparece, com zoom na tela, a conversa que ele está tendo com um cliente, que envia: "Oi! Preciso fazer uma reposição. Posso mandar os itens aqui?". Ele responde "Claro!".',
    title: "Soluções com IA",
    description: "Nossas soluções com IA sugerem produtos com base no histórico do cliente e transformam mensagens em pedidos em segundos",
    link: links.card6,
  },
]);

export default function (props) {
  const TitleTag = props.titleTag || 'h2';
  const links = props.links || {};
  const cards = props.cards || defaultCards(links);

  return (
    <Fragment>
      <section className="cards-estrategias-v2">
        <div className="container section-title">
          <TitleTag className='title'>
            Confira os diferenciais Mercos
          </TitleTag>
        </div>
        <div className="wrapper">
          {cards.map((card, index) => (
            <Card
              key={`estrategia-card-${index}`}
              imgSrc={card.imgSrc}
              imgAlt={card.imgAlt}
              title={card.title}
              description={card.description}
              link={card.link}
            />
          ))}
        </div>
      </section>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardsEstrategias/CardsEstrategiasHomeV2.jsx